const itemConfig = {};

const itemPrefix = 'land';
itemConfig.isLogin = `${itemPrefix}-isLogin`;
itemConfig.token = `${itemPrefix}-token`;

module.exports = itemConfig;
